<template>
    <div v-if="product" class="col-md-12 mb-md-3 p-3">
        <p class="title">
            <badge
                :class="{
                    'type-hybrid': product[PRODUCTS.fields.strain].toLowerCase() === 'hybrid',
                    'type-sativa': product[PRODUCTS.fields.strain].toLowerCase() === 'sativa',
                    'type-indica': product[PRODUCTS.fields.strain].toLowerCase() === 'indica'
                }"
                class="mr-2"
            >
                {{ product[PRODUCTS.fields.strain] }}
            </badge>
            {{ product[PRODUCTS.fields.name] }}
        </p>
        <p class="category mt-1">{{ product.id }}</p>
        <div class="d-flex mb-3">
            <span class="card-category flex-fill">{{ product[PRODUCTS.fields.type] }}</span>
            <span class="card-category flex-fill">THC {{ +product[PRODUCTS.fields.thcLevel] / 100 }}%</span>
            <span class="card-category flex-fill">CBD {{ +product[PRODUCTS.fields.cbdLevel] / 100 }}%</span>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table table-sm table-striped">
                    <tbody>
                        <tr>
                            <th scope="row">Unit Quantity</th>
                            <td>{{ item[ORDERS.items.unitQuantity] }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Unit Price ($)</th>
                            <td>${{ Big(item[ORDERS.items.unitPrice]).toFixed(2) }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Unit Size</th>
                            <td>{{ item[ORDERS.items.unitSize] }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Unit Gram EQ</th>
                            <td>{{ item[ORDERS.items.unitGramEQ] }}</td>
                        </tr>
                        <tr v-if="item[ORDERS.items.total]">
                            <th scope="row">Total ($)</th>
                            <td>${{ Big(item[ORDERS.items.total]).toFixed(2) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { Big } from 'big.js'
import { PRODUCTS, ORDERS } from 'db'
import { Badge } from '@/components/UIComponents'
export default {
    components: {
        Badge
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            Big,
            PRODUCTS,
            ORDERS,
            product: false,
            error: false
        }
    },
    async created() {
        try {
            this.product = await this.$store.dispatch('products/FETCH_PRODUCT_BY_ID_ONCE', {
                id: this.item.productId,
                shouldReturn: true
            })
        } catch (err) {
            this.error = err.message
        }
    }
}
</script>
